<template>
    <div class="user-nav"  @click="onClick" :class="{'is-active' : isMenuOpen}">
        <div class="login-icon"></div>

        <slot name="profile-label"></slot>

        <nav class="user-nav__menu" :class="{'is-active' : isMenuOpen}">
            <slot name="profile-menu"></slot>
        </nav>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                isMenuOpen:false
            }
        },
        methods: {
            onClick() {
                this.isMenuOpen = !this.isMenuOpen;
            }
        },
    }
</script>
